/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown>, limit: NonNullable<unknown> }} Assistant_Agent_Trial_Credits_LeftInputs */



/**
* | output |
* | --- |
* | "Trial: {count} of {limit} credits left" |
*
* @param {Assistant_Agent_Trial_Credits_LeftInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const assistant_agent_trial_credits_left = /** @type {((inputs: Assistant_Agent_Trial_Credits_LeftInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Assistant_Agent_Trial_Credits_LeftInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`Essai : ${i?.count} sur ${i?.limit} crédits restants`)
	if (locale === "de") return /** @type {LocalizedString} */ (`Testlauf: ${i?.count} von ${i?.limit} verbleibenden Credits`)
	if (locale === "it") return /** @type {LocalizedString} */ (`Prova: ${i?.count} di ${i?.limit} crediti rimanenti`)
	if (locale === "ru") return /** @type {LocalizedString} */ (`Испытание: осталось ${i?.count} из ${i?.limit} кредитов`)
	if (locale === "es") return /** @type {LocalizedString} */ (`Prueba: ${i?.count} de ${i?.limit} créditos restantes`)
	if (locale === "zh-CN") return /** @type {LocalizedString} */ (`试炼：剩余${i?.count}/${i?.limit}积分`)
	if (locale === "ja") return /** @type {LocalizedString} */ (`トライアル：残り${i?.count} / ${i?.limit}クレジット`)
	if (locale === "hi") return /** @type {LocalizedString} */ (`ट्रायल: ${i?.count} में से ${i?.limit} क्रेडिट शेष हैं`)
	if (locale === "pt-PT") return /** @type {LocalizedString} */ (`Teste: Restam ${i?.count} de ${i?.limit} créditos`)
	return /** @type {LocalizedString} */ (`Trial: ${i?.count} of ${i?.limit} credits left`)
});